var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('allocation-index')],1)}
var staticRenderFns = []

export { render, staticRenderFns }